import { render, staticRenderFns } from "./FeePrice.vue?vue&type=template&id=1891fea4&"
import script from "./FeePrice.vue?vue&type=script&lang=js&"
export * from "./FeePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports